import React from 'react';
import BothConnectedPdfDocument from './modes/BothConnectedPdfDocument';
import BothNotConnectedPdfDocument from './modes/BothNotConnectedPdfDocument';
import LottoOnlyPdfDocument from './modes/LottoOnlyPdfDocument';
import PosOnlyPdfDocument from './modes/PosOnlyPdfDocument';
import { AuditPdfDocumentProps } from './types';

const AuditReportPdfDocument: React.FC<AuditPdfDocumentProps> = ({ mode, ...rest }) => {
  if (mode === 'both_connected') return <BothConnectedPdfDocument {...rest} />;
  if (mode === 'both_not_connected') return <BothNotConnectedPdfDocument {...rest} />;
  if (mode === 'lotto_only') return <LottoOnlyPdfDocument {...rest} />;
  return <PosOnlyPdfDocument {...rest} />;
};

export default AuditReportPdfDocument;
